import React from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  icon?: React.ReactNode;
}
export function Input({
  label,
  error,
  icon,
  className = '',
  id,
  ...props
}: InputProps) {
  const inputId = id || props.name || Math.random().toString(36).substr(2, 9);
  return <div className="w-full" data-id="element-203">
      {label && <label htmlFor={inputId} className="block text-sm font-medium text-gray-700 mb-1.5 ml-1" data-id="element-204">
          {label}
        </label>}
      <div className="relative" data-id="element-205">
        {icon && <div className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" data-id="element-206">
            {icon}
          </div>}
        <input id={inputId} className={`
            w-full bg-white border border-gray-200 text-gray-900 text-sm rounded-xl
            focus:ring-2 focus:ring-orange-500/20 focus:border-orange-500 block p-3
            placeholder-gray-400 transition-all duration-200
            ${icon ? 'pl-10' : ''}
            ${error ? 'border-red-500 focus:ring-red-500/20 focus:border-red-500' : ''}
            ${className}
          `} {...props} data-id="element-207" />
      </div>
      {error && <p className="mt-1 text-xs text-red-500 ml-1" data-id="element-208">{error}</p>}
    </div>;
}